export const parseBigmarkerErrorMessage = ({ errorMessage }: { errorMessage: string }) => {
  const parsed = />"(?<temp1>[^"]+)"\}/.exec(errorMessage);
  return parsed ? parsed.groups?.temp1 : undefined;
};
